import React from 'react';

const ExpertiseStrip = () => {
  return (
    <div className="strip">
      <span className="strip-label">Domain Expertise</span>
      <div className="strip-divider"></div>
      <div className="strip-items">
        <span className="strip-item"><span className="strip-dot"></span>Financial Technology</span>
        <span className="strip-item"><span className="strip-dot"></span>E-Commerce & Retail</span>
        <span className="strip-item"><span className="strip-dot"></span>Banking & Payments</span>
        <span className="strip-item"><span className="strip-dot"></span>Human-Centric Apps</span>
        <span className="strip-item"><span className="strip-dot"></span>Enterprise SaaS</span>
        <span className="strip-item"><span className="strip-dot"></span>AI Consulting</span>
      </div>
    </div>
  );
};

export default ExpertiseStrip;